// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client_names{
    list-style:none;
    padding: 0px;
    overflow: auto;
    background-color: transparent;
    max-height: 515px;
}
.client_names li {
    color: black;
    padding: 5px 15px;
    /* background: #b3b0b0; */
    border-radius: 5px;
    margin-bottom: 2px;
    margin-top: 2px;


}
/* .row{
    overflow-y: auto;
    max-height: 550px;
}
.card{
    border: 0;
    position: relative;
    width: 100%;
    overflow: hidden;
    max-height: 552px;
    margin-bottom: 0px !important;
} */


.client_names li:hover{
    background: #e9e6e6 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;;AAGnB;AACA;;;;;;;;;;;GAWG;;;AAGH;IACI,8BAA8B;AAClC","sourcesContent":[".client_names{\n    list-style:none;\n    padding: 0px;\n    overflow: auto;\n    background-color: transparent;\n    max-height: 515px;\n}\n.client_names li {\n    color: black;\n    padding: 5px 15px;\n    /* background: #b3b0b0; */\n    border-radius: 5px;\n    margin-bottom: 2px;\n    margin-top: 2px;\n\n\n}\n/* .row{\n    overflow-y: auto;\n    max-height: 550px;\n}\n.card{\n    border: 0;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    max-height: 552px;\n    margin-bottom: 0px !important;\n} */\n\n\n.client_names li:hover{\n    background: #e9e6e6 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
